let deferredInstallPrompt = null

export function isStandaloneDisplay() {
  if (typeof window === 'undefined') return false
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || window.matchMedia('(display-mode: fullscreen)').matches
    || window.navigator.standalone === true
  )
}

export function canInstallPWA() {
  return !!deferredInstallPrompt
}

export function bindPWAInstallPrompt() {
  if (typeof window === 'undefined') return
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredInstallPrompt = e
    window.dispatchEvent(new Event('pwa-install-available'))
  })
  window.addEventListener('appinstalled', () => {
    deferredInstallPrompt = null
    window.dispatchEvent(new Event('pwa-installed'))
  })
}

export async function promptPWAInstall() {
  if (!deferredInstallPrompt) return false
  deferredInstallPrompt.prompt()
  const { outcome } = await deferredInstallPrompt.userChoice
  deferredInstallPrompt = null
  return outcome === 'accepted'
}

export async function enterNativeFullscreen() {
  if (typeof document === 'undefined') return false
  const el = document.documentElement
  if (!el.requestFullscreen) return false
  if (document.fullscreenElement) return true
  try {
    await el.requestFullscreen()
    return true
  } catch {
    return false
  }
}

export async function exitNativeFullscreen() {
  if (typeof document === 'undefined') return
  if (document.fullscreenElement && document.exitFullscreen) {
    try {
      await document.exitFullscreen()
    } catch {
      /* ignore */
    }
  }
}

export function applyKioskClasses(on) {
  const method = on ? 'add' : 'remove'
  document.documentElement.classList[method]('workspace-fs-active')
  document.body.classList[method]('workspace-fs-active')
}
